/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_Archived_SuccessInputs */

const en_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot description job archived successfully.`)
};

const fr_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan archivée avec succès.`)
};

const de_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftragsbeschreibung erfolgreich archiviert.`)
};

const it_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dell'inquadratura archiviata con successo.`)
};

const ru_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание по описанию кадра успешно завершено.`)
};

const es_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de la toma archivada con éxito.`)
};

const zh_cn2_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述任务已成功存档。`)
};

const ja_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の説明が正常にアーカイブされました。`)
};

const hi_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण कार्य सफलतापूर्वक संग्रहीत हो गया।`)
};

const pt_pt2_scene_description_job_archived_success = /** @type {(inputs: Scene_Description_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa de descrição da cena arquivada com sucesso.`)
};

/**
* | output |
* | --- |
* | "Shot description job archived successfully." |
*
* @param {Scene_Description_Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_archived_success = /** @type {((inputs?: Scene_Description_Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_job_archived_success(inputs)
	if (locale === "de") return de_scene_description_job_archived_success(inputs)
	if (locale === "it") return it_scene_description_job_archived_success(inputs)
	if (locale === "ru") return ru_scene_description_job_archived_success(inputs)
	if (locale === "es") return es_scene_description_job_archived_success(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_job_archived_success(inputs)
	if (locale === "ja") return ja_scene_description_job_archived_success(inputs)
	if (locale === "hi") return hi_scene_description_job_archived_success(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_job_archived_success(inputs)
	return en_scene_description_job_archived_success(inputs)
});